@if (lowestPrice) {
  <span class="d-block">
    {{"LEASE_PRICE"|translate}} @if (parsedPricesList && parsedPricesList.length > 1) {
    <span class="text-lowercase">{{'FROM_MIN_PRICE'|translate}}</span>
    }@if (parsedPricesList && parsedPricesList.length > 1) {
    &nbsp;
    }<span innerHTML="{{lowestPrice.value  | currencyConvert: lowestPrice.currency}} {{'PER_MONTH'|translate}} {{'PRICE_INCL_VAT'|translate}}"></span>
    @if (showTable && parsedPricesList && parsedPricesList.length > 1) {
      <i class="material-icons light popoverTrigger" triggers="mouseenter:mouseleave" placement="bottom"
        [ngbPopover]="volumeContent" [popoverTitle]="'LEASE_PRICES' | translate" #p="ngbPopover" [autoClose]="'mouseleave'">arrow_drop_down
      </i>
    }
  </span>
}

<ng-container>
  <ng-template #volumeContent>
    <table class="table">
      <thead class="fw-bold">
        <tr>
          <td>{{ 'MONTHS' | translate }}</td>
          <td>{{ 'PRICE' | translate }}</td>
        </tr>
      </thead>
      <tbody>
        @for (priceData of parsedPricesList; track priceData) {
          <tr>
            <td>{{priceData.volume}} &times;</td>
            <td [innerHTML]="priceData.value | currencyConvert: priceData.currency "></td>
          </tr>
        }
      </tbody>
    </table>
  </ng-template>
</ng-container>

@if (((selectedDuration && parsedPrices[selectedDuration]))) {
  <div>
    {{"LEASE_PRICE"|translate}} &euro; {{parsedPrices[selectedDuration]["value"]}},- {{"PER_MONTH"|translate}} {{'PRICE_INCL_VAT'|translate}}
  </div>
}
